<template>
    <WalletAnnoucement/>
   <router-view v-if="init" :key="$route.fullPath"></router-view>
</template>

<script>
import { computed, defineAsyncComponent } from 'vue';
import { getWalletAuth} from '../services/module';
import WalletAnnoucement from '../components/WalletAnnoucement.vue';
import WalletHistory from '../components/WalletHistory.vue';
export default {
    name: "WalletModule",
    components: {
		WalletHistory,
        WalletAnnoucement
    },
    data() {
        return {
            init: false,
            config: null,
            walletData: null
        }
    },
    provide() {
        return { 
            walletConfig : computed(() => this.config)
        }
    },
    created() {
        if(!this.$auth?.user?.isDemoLogin){
            this.getWalletAuth();
        }else{
            this.$errorToast('Wallet access is restricted for demo users')
            this.$router.push({name:'Home'})
        }
    },
    methods: {
        async getWalletAuth() {
            try {
                let response = await getWalletAuth();
                if(response?.data){
                    this.config = response.data
                    this.init = true
                }
            } catch (error) {
                this.$errorToast(error)
            }
        }
    }
}
</script>